"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeUndoRedo = void 0;
const _1 = require(".");
function makeUndoRedo() {
    return new UndoRedoImp();
}
exports.makeUndoRedo = makeUndoRedo;
class UndoRedoImp {
    constructor() {
        this.observers = new _1.ObserverList();
        this.undoRedoers = [];
        this.undoStack = [];
        this.redoStack = [];
        this.doUndo = () => {
            const action = this.undoStack.pop();
            if (!action) {
                console.warn("[UndoRedo] nothing to undo");
                return;
            }
            this.redoStack.push(action);
            this.undoRedoers.forEach(undoers => undoers.undoAction(action));
            this.observers.notify();
        };
        this.doRedo = () => {
            const action = this.redoStack.pop();
            if (!action) {
                console.warn("[UndoRedo] nothing to redo");
                return;
            }
            this.undoStack.push(action);
            this.undoRedoers.forEach(redoers => redoers.redoAction(action));
            this.observers.notify();
        };
        this.submitAction = (action) => {
            this.undoStack.push(action);
            this.redoStack = [];
            this.observers.notify();
        };
        this.clearStack = () => {
            this.redoStack = [];
            this.undoStack = [];
            this.observers.notify();
        };
        this.registerUndoRedoer = (undoredoer) => {
            this.undoRedoers.push(undoredoer);
        };
        this.addObserver = (observer) => {
            this.observers.add(observer);
        };
        this.removeObserver = (observer) => {
            this.observers.remove(observer);
        };
    }
    get hasUndo() {
        return this.undoStack.length > 0;
    }
    get hasRedo() {
        return this.redoStack.length > 0;
    }
}
